import React from "react";
import ModalFiltering from "./FormElements/ModalFiltering";
import IconClose from "../Resources/svg/Icons/IconClose";

const ModalTerminos = ({ openModalMessagePDP, setOpenModalMessagePDP }) => {

  return (
    <div className="modalAttach">
      <ModalFiltering
        className={`modal-result is-midle ${openModalMessagePDP && "is-open"}`}
        variant={true}
      >
        <div
          className="modal-filtering__close"
          onClick={() => setOpenModalMessagePDP(false)}
        >
          <IconClose />
        </div>
        <h2 className="modal-result__title">
          TÉRMINOS Y CONDICIONES PARA EL TRATAMIENTO DE DATOS PERSONALES
        </h2>
        <div className="modal-result__content">
          <p
            style={{ textAlign: "justify" }}
            className="modal-result__subtitle"
          >
            Conforme a lo establecido en la Ley N° 29733 - Ley de Protección de
            Datos Personales y en el Decreto Supremo 003-2013/JUS - Reglamento
            de la Ley, otorgo mi consentimiento libre, previo, informado,
            expreso e inequívoco para que Rímac Seguros y Reaseguros (en
            adelante, "RIMAC SEGUROS") realice el tratamiento de mis datos
            personales, sean estos proporcionados de forma física o digital (en
            adelante, los "Datos Personales"), con la finalidad de que se
            efectúe la cotización para la contratación futura de un seguro
            inversión. A tal efecto, declaro haber sido informado que tengo el
            derecho a revocar este consentimiento en cualquier momento.
            <br />
            <br />
            Asimismo, y para la finalidad descrita en el párrafo precedente,
            declaro conocer y aceptar que RIMAC SEGUROS tiene la facultad de
            realizar el tratamiento de mis Datos Personales por encargo a
            terceros, pudiendo transferirlos a nivel nacional y/o internacional
            a las empresas subsidiarias, filiales, asociadas, afiliadas o
            miembros del Grupo Económico al que pertenece, además de otras
            empresas, cuyo listado completo se encuentra en el enlace
            "Protección de Datos Personales" ubicado en www.rimac.com.pe,
            sujetándose a las mismas obligaciones de seguridad, técnicas y
            legales.
            <br />
            <br />
            Declaro haber sido informado que la autorización brindada para el
            tratamiento de mis Datos Personales será válida hasta por diez (10)
            años de brindado el consentimiento, siendo mis Datos Personales
            almacenados en el banco de Datos de RIMAC SEGUROS, domiciliada en
            Av. Paseo de la República 3505, Piso 11, San Isidro, Lima, inscrito
            en el Registro Nacional de Protección de Datos Personales con la
            denominación "Potenciales Clientes" con código RNPDP-PJP N° 1635.
            <br />
            <br />
            Finalmente, declaro conocer que tengo el derecho a solicitar el
            acceso a mis Datos Personales y conocer su tratamiento, así como a
            solicitar su actualización, inclusión, rectificación, cancelación y
            supresión, pudiendo oponerme a su uso o divulgación, a través de
            cualquiera de las Plataformas de Atención de RIMAC SEGUROS ,
            teniendo a salvo además el ejercicio de la tutela de mis derechos
            ante la Autoridad Nacional de Protección de Datos Personales en vía
            de reclamación o ante el Poder Judicial mediante la acción de hábeas
            data.
            <br />
            <br />
          </p>
        </div>
      </ModalFiltering>
    </div>
  );
};

export default ModalTerminos;